/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebfieldpostalcode4Inputs */

const en_placewebfieldpostalcode4 = /** @type {(inputs: Placewebfieldpostalcode4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postcode`)
};

const de_placewebfieldpostalcode4 = /** @type {(inputs: Placewebfieldpostalcode4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLZ`)
};

/**
* | output |
* | --- |
* | "Postcode" |
*
* @param {Placewebfieldpostalcode4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebfieldpostalcode4 = /** @type {((inputs?: Placewebfieldpostalcode4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebfieldpostalcode4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebfieldpostalcode4(inputs)
	return de_placewebfieldpostalcode4(inputs)
});
export { placewebfieldpostalcode4 as "placeWebFieldPostalCode" }